import type { NsHandle } from "react-i18next";

export const namespaces: NsHandle["i18n"] = [
  "breadcrumbs",
  "casino",
  "common",
  "footer",
  "home",
  "info",
  "lootBox",
  "mainBanner",
  "promotions",
  "series",
  "support",
];
